import { useControl, useControlEffect } from "@react-typed-forms/core";
import { useApiClient } from "@astroapps/client";
import { ApplicationClient } from "hwc-common/hwc/client.ts";
import { useNavigate } from "@tanstack/react-router";
import { confirmRoute } from "./routes.tsx";

export function ConfirmationPage() {
  const params = confirmRoute.useParams();
  const navigate = useNavigate();
  const verifying = useControl(true, {
    dontClearError: true,
  });
  const client = useApiClient(ApplicationClient);

  useControlEffect(
    () => params.confirmationCode,
    async (vc) => {
      try {
        await client.confirmApplication(vc);
        // Fake delay to see spinner
        await new Promise((resolve) => setTimeout(resolve, 1500));
      } catch (e: any) {
        verifying.error = e.detail;
      } finally {
        verifying.value = false;
      }
    },
    true,
  );

  return (
    <div className="mt-10 flex justify-center">
      <div className="plate w-full max-w-md px-8 py-10 text-center">
        {verifying.value ? (
          <div className="text-surface-700">
            <i className="fa fa-circle-notch fa-spin text-3xl text-primary-600" />
            <p className="mt-4 text-lg">Confirming your application…</p>
          </div>
        ) : verifying.error != null ? (
          <div className="text-danger-700">
            <i className="fas fa-circle-xmark text-3xl" />
            <h2 className="mt-3 text-2xl font-semibold uppercase">
              Couldn't confirm
            </h2>
            <p className="mt-2 text-surface-600">{verifying.error}</p>
          </div>
        ) : (
          <div>
            <i className="fas fa-check-circle text-3xl text-primary-600" />
            <h2 className="mt-3 text-2xl font-semibold text-secondary-800 uppercase">
              Application confirmed
            </h2>
            <p className="mt-2 text-surface-600">
              We'll review your application and be in touch soon!
            </p>
          </div>
        )}
        {!verifying.value && (
          <div className="mt-6">
            <button
              className="btn btn-primary"
              onClick={() => navigate({ to: "/" })}
            >
              Done
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
